import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./card_slide.css";
import { Button, Text } from "@mantine/core";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Tooltip,
} from "@material-tailwind/react";
export const SlideData = [
  {
    id: 1,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2040.png?alt=media&token=9a29171d-116a-489b-9606-93696362dc4e",
  },
  {
    id: 2,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2053.png?alt=media&token=01eb57a4-f464-4a41-b0fc-1e1eddfe7108",
  },
  {
    id: 3,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2054.png?alt=media&token=66dd5beb-8c64-4978-9501-5b788f3eab16",
  },
  {
    id: 4,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2052.png?alt=media&token=4e7840ca-2047-45d7-82e3-950b0fa1b964",
  },
];

const CardSlide = () => {
  const [defaultImage, setDefaultImage] = useState({});
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleErrorImage = (data) => {
    setDefaultImage((prev) => ({
      ...prev,
      [data.target.alt]: data.target.alt,
      linkDefault: "",
    }));
  };

  return (
    <div className="App mb-20">
      <Text className="text-center text-xl text-[#737373] border-b-yellow-500 border-b-2 w-[120px] mx-auto uppercase">
        best seller
      </Text>
      <Slider {...settings}>
        {SlideData.map((item) => (
          // <div key={item.id} className="card">
          //   <div className="card-top">
          //     <img src={item.img} alt={item.name} onError={handleErrorImage} />
          //     <h1>{item.name}</h1>
          //   </div>
          //   <div className="card-bottom">
          //     <h3>{item.price}</h3>
          //     <span className="category">{item.name}</span>
          //   </div>
          //   <button className="bg-white px-5 rounded hover:scale-105 transition outline-none border-none text-xs py-2 mt-3 ml-4 text-gray-800 font-bold uppercase">
          //     shop now
          //   </button>
          // </div>
          <Card className="w-96" key={item.id}>
            <CardHeader floated={false} className="h-80">
              <img
                src={item.img}
                alt="profile-picture"
                className="h-full w-full object-center object-cover"
              />
            </CardHeader>
            <CardBody className="text-center">
              <Typography
                variant="h5"
                color="blue-gray"
                className="mb-2 font-light"
              >
                {item.name}
              </Typography>
              <Typography
                color="blue"
                className="font-medium text-xs"
                textGradient
              >
                {item.cate}
              </Typography>
            </CardBody>
            <CardFooter className="flex justify-center gap-7 pt-2">
              <Tooltip content="Like">
                <Typography
                  as="a"
                  href="#facebook"
                  variant="lead"
                  color="blue"
                  textGradient
                >
                  <i className="fab fa-facebook" />
                </Typography>
              </Tooltip>
              <Tooltip content="Follow">
                <Typography
                  as="a"
                  href="#twitter"
                  variant="lead"
                  color="light-blue"
                  textGradient
                >
                  <i className="fab fa-twitter" />
                </Typography>
              </Tooltip>
              <Tooltip content="Follow">
                <Typography
                  as="a"
                  href="#instagram"
                  variant="lead"
                  color="purple"
                  textGradient
                >
                  <i className="fab fa-instagram" />
                </Typography>
              </Tooltip>
            </CardFooter>
          </Card>
        ))}
      </Slider>
    </div>
  );
};

export default CardSlide;
